import React from "react";
import NextImage from "../../common/NextImage";
import NoDataFound from "../../common/NoDataFound";
import { getImageUrl } from "../../../utils/generalLiveCenter";

const TableTeam = ({ teamTable, dictionary }) => {
  const rows = teamTable?.football_tournament_tables || [];

  return (
    <div className="global_table standing_table">
      {rows.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>{dictionary?.team || "Team"}</th>
              <th>{dictionary?.played || "P"}</th>
              <th>{dictionary?.won || "W"}</th>
              <th>{dictionary?.draw || "D"}</th>
              <th>{dictionary?.lost || "L"}</th>
              <th>{dictionary?.goals_for || "F"}</th>
              <th>{dictionary?.goals_against || "A"}</th>
              <th>{dictionary?.goal_diff || "GD"}</th>
              <th>{dictionary?.points || "PTS"}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((data, index) => (
              <tr key={data?.team_id || index}>
                <td>{index + 1}</td>
                <td>
                  <div className="des-wrap">
                    <span className="flg_img">
                      <NextImage
                        src={getImageUrl('', '', 'football', data?.team_id)}
                        height={23}
                        width={23}
                        alt={data?.team?.nm || "team logo"}
                        priority={false}
                      />
                    </span>
                    <span className="des-text">
                      {data?.team?.nm || data?.team || "N/A"}
                    </span>
                  </div>
                </td>
                <td>{data?.pld ?? "-"}</td>
                <td>{data?.w ?? "-"}</td>
                <td>{data?.d ?? "-"}</td>
                <td>{data?.l ?? "-"}</td>
                <td>{data?.scr ?? "-"}</td>
                <td>{data?.con ?? "-"}</td>
                <td>{data?.dif ?? "-"}</td>
                <td>{data?.pts ?? "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default TableTeam;
